import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("thrive_admin_token") || ""}` });

export const admin = {
  login: (email, password) => axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data),
  me: () => axios.get(`${API}/auth/me`, { headers: authHeaders() }).then((r) => r.data),
  overview: () => axios.get(`${API}/admin/overview`, { headers: authHeaders() }).then((r) => r.data),
  leads: (params) => axios.get(`${API}/admin/leads`, { params, headers: authHeaders() }).then((r) => r.data),
  lead: (id) => axios.get(`${API}/admin/leads/${id}`, { headers: authHeaders() }).then((r) => r.data),
  update: (id, body) => axios.patch(`${API}/admin/leads/${id}`, body, { headers: authHeaders() }).then((r) => r.data),
  notifications: () => axios.get(`${API}/admin/notifications`, { headers: authHeaders() }).then((r) => r.data),
  modelSetting: () => axios.get(`${API}/admin/settings/model`, { headers: authHeaders() }).then((r) => r.data),
  setModel: (provider) => axios.patch(`${API}/admin/settings/model`, { provider }, { headers: authHeaders() }).then((r) => r.data),
};

export const growth = {
  start: (start_option) => axios.post(`${API}/growth/sessions`, { start_option }).then((r) => r.data),
  session: (id) => axios.get(`${API}/growth/sessions/${id}`).then((r) => r.data),
  builder: (form) => axios.post(`${API}/growth/builder`, form).then((r) => r.data),
  lead: (body) => axios.post(`${API}/growth/leads`, body).then((r) => r.data),
};

export async function streamMessage(sessionId, text, onToken, onDone, signal) {
  const res = await fetch(`${API}/growth/sessions/${sessionId}/message`, {
    method: "POST",
    signal,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ text }),
  });
  if (!res.ok || !res.body) throw new Error("stream failed");
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const ev = JSON.parse(p.slice(6));
      if (ev.t) onToken(ev.t);
      if (ev.error) onToken(`\n${ev.error}`);
      if (ev.done) onDone(ev);
    }
  }
}

export const formatError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return String(d);
};
